/**
 * Convert a hex-encoded MD5 digest (the 32-char string SparkMD5 produces) into
 * the base64 string Active Storage's direct-upload `checksum` expects — i.e.
 * the equivalent of Ruby's `Digest::MD5.base64digest`.
 *
 * Pure and deterministic (no FileReader / SparkMD5 / DOM), so the wire-format
 * conversion can be unit-tested directly. The component's `calculateMD5Base64`
 * is left as thin FileReader glue around this.
 */
export function hexDigestToBase64(hexDigest: string): string {
  const pairs = hexDigest.match(/.{2}/g);
  if (!pairs) return '';

  const bytes = new Uint8Array(pairs.map((pair) => parseInt(pair, 16)));
  return btoa(String.fromCharCode(...bytes));
}
